import * as Vendor from '@/services/rest-api/lib/vendor/vendor'
import * as MarketingUser from '@/services/rest-api/lib/customer/marketing-user'
import errorMessageList from '../constants/error-message-mapper'
import { errorMessage } from '@/helpers/errorHandler'
import { TMS_MARKETING_USER_FILTER } from '@/helpers/tms-access'

export const contractTypes = [
  { id: 'ONCALL', name: 'On Call' },
  // { id: 'DEDICATED', name: 'Dedicated' },
  // { id: 'PROJECT', name: 'Project' },
]

export const pricingMethods = [
  { id: 'TRIP', name: 'Per Trip' },
  // { id: 'PER_KG', name: 'Per KG' },
  // { id: 'PER_VOLUME', name: 'Per Volume' },
]

export const contractDetailFieldsCreateFromVendorPage = [
  {
    name: 'vendor_id',
    label: 'Nama Vendor',
    placeholder: 'Pilih Nama Vendor',
    validation: 'required',
    type: 'select-resourceful',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj.vendor,
    optionsGetter: Vendor.get,
    disabled: true,
  },
  {
    name: 'reference',
    label: 'Referensi',
    placeholder: 'Masukkan Referensi',
    validation: "multipleSpaces"
  },
  {
    name: 'contract_type',
    label: 'Jenis Kontrak',
    placeholder: 'Pilih Jenis Kontrak',
    type: 'select-resourceful',
    validation: 'required',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => contractTypes.find((type) => type.id === obj.contract_type),
    optionsGetter: contractTypeGetter,
  },
  {
    name: 'pricing_method',
    label: 'Jenis Penetapan Harga',
    placeholder: 'Pilih Jenis Penetapan Harga',
    type: 'select-resourceful',
    validation: 'required',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => pricingMethods.find((method) => method.id === obj.pricing_method),
    optionsGetter: pricingMethodGetter,
  },
  {
    // Auto filled → current date/today, when the contract document is created.
    name: 'effective_date',
    label: 'Tanggal Mulai',
    placeholder: 'Pilih Tanggal Mulai',
    type: 'date-picker',
    validation: 'required',
    format: 'DD MMM YYYY',
    valueType: 'YYYY-MM-DD',
  },
  {
    // Auto filled → based on period and contract duration and start date of contract.
    name: 'expired_date',
    label: 'Tanggal Berakhir',
    placeholder: 'Pilih Tanggal Berakhir',
    type: 'date-picker',
    validation: 'required',
    format: 'DD MMM YYYY',
    valueType: 'YYYY-MM-DD',
  },
  {
    name: 'payment_term',
    label: 'Term of Payment',
    type: 'counter',
    validation: 'bail|required|number|min:0,value',
    suffix: 'hari sejak tanggal diterbitkan faktur',
    min: 0,
  },
  {
    name: 'custodian_id',
    label: 'Penanggung Jawab',
    placeholder: 'Pilih Penanggung Jawab',
    type: 'select-resourceful',
    validation: 'required',
    optionsGetter: MarketingUser.get(TMS_MARKETING_USER_FILTER),
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => (obj?.custodian ? obj.custodian : obj),
  },
  {
    name: 'note',
    label: 'Catatan',
    placeholder: 'Masukkan Catatan',
    type: 'textarea',
    colAttrs: {
      md: 6,
    },
  },
]

export const contractDetailFields = [
  {
    name: 'vendor_id',
    label: 'Nama Vendor',
    placeholder: 'Pilih Nama Vendor',
    validation: 'required',
    type: 'select-resourceful',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj.vendor,
    optionsGetter: Vendor.get,
  },
  {
    name: 'reference',
    label: 'Referensi',
    placeholder: 'Masukkan Referensi',
    validation: "multipleSpaces"
  },
  {
    name: 'contract_type',
    label: 'Jenis Kontrak',
    placeholder: 'Pilih Jenis Kontrak',
    type: 'select-resourceful',
    validation: 'required',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => contractTypes.find((type) => type.id === obj.contract_type),
    optionsGetter: contractTypeGetter,
  },
  {
    name: 'pricing_method',
    label: 'Jenis Penetapan Harga',
    placeholder: 'Pilih Jenis Penetapan Harga',
    type: 'select-resourceful',
    validation: 'required',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => pricingMethods.find((method) => method.id === obj.pricing_method),
    optionsGetter: pricingMethodGetter,
  },
  {
    // Auto filled → current date/today, when the contract document is created.
    name: 'effective_date',
    label: 'Tanggal Mulai',
    placeholder: 'Pilih Tanggal Mulai',
    type: 'date-picker',
    validation: 'required',
    format: 'DD MMM YYYY',
    valueType: 'YYYY-MM-DD',
  },
  {
    // Auto filled → based on period and contract duration and start date of contract.
    name: 'expired_date',
    label: 'Tanggal Berakhir',
    placeholder: 'Pilih Tanggal Berakhir',
    type: 'date-picker',
    validation: 'required|dateGteField:effective_date',
    validationMessages: {
      dateGteField: errorMessage(errorMessageList['expired lower than effective']),
    },
    format: 'DD MMM YYYY',
    valueType: 'YYYY-MM-DD',
  },
  {
    name: 'payment_term',
    label: 'Term of Payment',
    type: 'counter',
    validation: 'bail|required|number|min:0,value',
    suffix: 'hari sejak tanggal diterbitkan faktur',
    min: 0,
  },
  {
    name: 'custodian_id',
    label: 'Penanggung Jawab',
    placeholder: 'Pilih Penanggung Jawab',
    type: 'select-resourceful',
    validation: 'required',
    optionsGetter: MarketingUser.get(TMS_MARKETING_USER_FILTER),
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => (obj?.custodian ? obj.custodian : obj),
  },
  {
    name: 'note',
    label: 'Catatan',
    placeholder: 'Masukkan Catatan',
    type: 'textarea',
    colAttrs: {
      md: 6,
    },
  },
]

export const contractDetailFieldsAddendum = [
  {
    name: 'vendor_id',
    label: 'Nama Vendor',
    placeholder: 'Pilih Nama Vendor',
    validation: 'required',
    type: 'select-resourceful',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj.vendor,
    optionsGetter: Vendor.get,
    disabled: true,
  },
  {
    name: 'reference',
    label: 'Referensi',
    placeholder: 'Masukkan Referensi',
    validation: "multipleSpaces"
  },
  {
    name: 'contract_type',
    label: 'Jenis Kontrak',
    placeholder: 'Pilih Jenis Kontrak',
    type: 'select-resourceful',
    validation: 'required',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => contractTypes.find((type) => type.id === obj.contract_type),
    optionsGetter: contractTypeGetter,
  },
  {
    name: 'pricing_method',
    label: 'Jenis Penetapan Harga',
    placeholder: 'Pilih Jenis Penetapan Harga',
    type: 'select-resourceful',
    validation: 'required',
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => pricingMethods.find((method) => method.id === obj.pricing_method),
    optionsGetter: pricingMethodGetter,
  },
  {
    // Auto filled → current date/today, when the contract document is created.
    name: 'effective_date',
    label: 'Tanggal Mulai',
    placeholder: 'Pilih Tanggal Mulai',
    type: 'date-picker',
    validation: 'required',
    format: 'DD MMM YYYY',
    valueType: 'YYYY-MM-DD',
  },
  {
    // Auto filled → based on period and contract duration and start date of contract.
    name: 'expired_date',
    label: 'Tanggal Berakhir',
    placeholder: 'Pilih Tanggal Berakhir',
    type: 'date-picker',
    validation: 'required|dateGteField:effective_date',
    validationMessages: {
      dateGteField: errorMessage(errorMessageList['expired lower than effective']),
    },
    format: 'DD MMM YYYY',
    valueType: 'YYYY-MM-DD',
  },
  {
    name: 'payment_term',
    label: 'Term of Payment',
    type: 'counter',
    validation: 'bail|required|number|min:0,value',
    suffix: 'hari sejak tanggal diterbitkan faktur',
    min: 0,
  },
  {
    name: 'custodian_id',
    label: 'Penanggung Jawab',
    placeholder: 'Pilih Penanggung Jawab',
    type: 'select-resourceful',
    validation: 'required',
    optionsGetter: MarketingUser.get(TMS_MARKETING_USER_FILTER),
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => (obj?.custodian ? obj.custodian : obj),
  },
  {
    name: 'note',
    label: 'Catatan',
    placeholder: 'Masukkan Catatan',
    type: 'textarea',
    colAttrs: {
      md: 6,
    },
  },
]

async function contractTypeGetter() {
  return {
    metadata: { total_page: 1, total_count: 3, page: 1 },
    data: {
      paginated_result: [...contractTypes],
    },
  }
}

async function pricingMethodGetter() {
  return {
    metadata: { total_page: 1, total_count: 3, page: 1 },
    data: {
      paginated_result: [...pricingMethods],
    },
  }
}

export default contractDetailFields
